export const Slash = () => {
  return (
    <svg width="17" height="23" viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="16.2022" y1="0.147043" x2="0.202183" y2="22.147" stroke="black" strokeWidth="0.5" />
    </svg>
  );
};
